import { Flex, FormLabel, Icon, Tooltip } from "@chakra-ui/react";
import { MdHelpOutline } from "react-icons/md";
import { labelStyles } from "./styleTokens";

type Props = {
  children: React.ReactNode;
  /** Texto da ajuda. Sem ele, o label é só um FormLabel comum. */
  ajuda?: React.ReactNode;
};

/**
 * Rótulo de campo com ajuda em tooltip.
 *
 * A explicação fica atrás de um ícone em vez de virar texto sob o campo: o
 * formulário tem muitos campos por linha, e uma frase debaixo de cada um
 * empurra a mensagem — que é o trabalho de verdade — para fora da tela. Quem
 * já sabe não lê nada; quem tem dúvida passa o mouse.
 *
 * O `mb={0}` e o `mb={2}` no Flex mantêm o espaçamento que o FormLabel do
 * Chakra daria sozinho, para o alinhamento não mudar onde o label é trocado.
 */
export default function CampoLabel({ children, ajuda }: Props) {
  if (!ajuda) return <FormLabel {...labelStyles}>{children}</FormLabel>;

  return (
    <Flex align="center" gap={1.5} mb={2}>
      <FormLabel {...labelStyles} mb={0}>
        {children}
      </FormLabel>
      <Tooltip label={ajuda} placement="top" openDelay={200} hasArrow maxW="280px">
        {/* tabIndex deixa a ajuda alcançável pelo teclado, não só pelo mouse. */}
        <span tabIndex={0} style={{ display: "inline-flex", cursor: "help" }}>
          <Icon as={MdHelpOutline} boxSize={3.5} color="gray.400" aria-label="Ajuda" />
        </span>
      </Tooltip>
    </Flex>
  );
}
